import { render, staticRenderFns } from "./CustomerTestsList.vue?vue&type=template&id=3f0e5f6c&scoped=true&"
import script from "./CustomerTestsList.vue?vue&type=script&lang=js&"
export * from "./CustomerTestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0e5f6c",
  null
  
)

export default component.exports